/**
 * Created by Ewald Stamp (ewald.stamp@netmills.de) on 04.02.15.
 */
angular.module('cfn').factory('bookingMaskArguments', function() {
  function BookingMaskArguments() {
    this.clear = function() {
      this.fields = [];
      this.activityId = null;
      this.startDate = null;
      this.isSeptoriaTreatment = false;
      this.useArguments = false;
      this.data = null;
    };

    this.copy = function() {
      return angular.copy(this);
    };

    this.clear();
  }

  return new BookingMaskArguments();
});
